import { computed as e, h as c } from "vue";
import n from "./design-system.es153.js";
/* empty css                    */
import d from "./design-system.es128.js";
const u = {
  name: "DsStack",
  props: {
    /**
     * Gap spacing of the stack layout
     */
    space: {
      type: [String],
      default: null,
      validator: (t) => n.includes(t)
    },
    /**
     * HTML tag to render the component as
     */
    as: {
      type: String,
      default: "div"
    },
    /**
     * Horizontal alignment of the items
     */
    alignX: {
      type: String,
      default: null,
      validator: (t) => ["left", "center", "right"].includes(t)
    },
    /**
     * Vertical alignment of the items
     */
    alignY: {
      type: String,
      default: "top",
      validator: (t) => ["top", "center", "bottom"].includes(t)
    },
    /**
     * Determines whether the items should grow to fill the available space
     */
    fill: {
      type: Boolean,
      default: !1
    },
    /**
     * Determines whether the items should be evenly spaced to fill the available space
     */
    spread: {
      type: Boolean,
      default: !1
    }
  },
  setup(t, { slots: s }) {
    const l = e(() => {
      const a = [
        "ds-stack",
        `ds-stack--align-y-${t.alignY}`
      ];
      return t.alignX && a.push(`ds-stack--align-x-${t.alignX}`), t.fill && a.push("ds-stack--fill"), t.spread && a.push("ds-stack--spread"), t.space && a.push("ds-stack--space"), a;
    }), i = e(() => ({
      "--ds-stack-spacing": t.space ? `var(--ds-${t.space})` : "0"
    }));
    return () => c(
      t.as,
      {
        class: l.value,
        style: i.value
      },
      s.default()
    );
  }
}, g = /* @__PURE__ */ d(u, [["__scopeId", "data-v-45269fdb"]]);
export {
  g as default
};
//# sourceMappingURL=design-system.es94.js.map
